<template>
  <div class="form-group row">
    <label class="col-form-label col-lg-2">Phones</label>
    <div class="col-lg-10">
      <div v-for="(phone, index) in phones" :key="index" class="mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <select
              class="input-group-text form-control bg-light"
              v-model="phone.countryCode"
              @change="emitUpdate"
            >
              <option
                v-for="code in countryCodes"
                :key="code.value"
                :value="code.value">
                {{ code.label }}
              </option>
            </select>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Phone Number"
            v-model="phone.phoneNumber"
            @input="emitUpdate"
          />
          <div class="input-group-append">
            <select
              class="input-group-text form-control bg-light"
              v-model="phone.phoneType"
              @change="emitUpdate"
            >
              <option value="MOBILE">Mobile</option>
              <option value="WORK">Work</option>
              <option value="HOME">Home</option>
              <option value="OTHER">Other</option>
            </select>
          </div>
          <div class="input-group-append" v-if="allowMultiple && phones.length > 1">
            <button
              class="btn btn-outline-danger"
              type="button"
              style="z-index: auto; border: 1px solid #ced4da;"
              @click="removePhone(index)"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="mt-2" v-if="allowMultiple && canAddMore">
        <a href="#" class="text-primary" @click.prevent="addPhone">
          <i class="fas fa-plus-circle mr-1"></i> Add another phone
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneNumbersSection',
  props: {
    value: {
      type: Array,
      required: true
    },
    countryCodes: {
      type: Array,
      required: true
    },
    maxItems: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      phones: []
    };
  },
  computed: {
    allowMultiple() {
      return this.maxItems === null || this.maxItems > 1;
    },
    canAddMore() {
      if (this.maxItems === null) return true;
      return this.phones.length < this.maxItems;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.phones = newVal;
      },
      deep: true
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('input', this.phones);
    },
    addPhone() {
      this.phones.push({
        countryCode: "263",
        phoneNumber: "",
        phoneType: "MOBILE"
      });
      this.emitUpdate();
    },
    removePhone(index) {
      this.phones.splice(index, 1);
      this.emitUpdate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContactDetails/sections/PhoneNumbersSection.vue